module.exports = {
    logError: function(err) {
        console.log(err);
    }
}